"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapJazzbandDedupedPageStateIssues = void 0;
const axe_devtools_issues_utils_1 = require("@deque/axe-devtools-issues-utils");
const mapJazzbandDedupedResultIssues_1 = require("./mapJazzbandDedupedResultIssues");
const mapJazzbandDedupedPageStateIssues = (pageState) => {
    return pageState.result.flatMap((result) => result.uniques.map((unique) => ({
        ...(0, mapJazzbandDedupedResultIssues_1.mapJazzbandDedupedResultIssues)(result, unique),
        pageStateKey: (0, axe_devtools_issues_utils_1.buildPageStateKey)(pageState)
    })));
};
exports.mapJazzbandDedupedPageStateIssues = mapJazzbandDedupedPageStateIssues;
//# sourceMappingURL=mapJazzbandDedupedPageStateIssues.js.map